import BreadcrumbWrapper from '@Components/BreadcrumbWrapper';
import PurchaseList from '@Components/Purchases/PurchaseList';

export default function Purchases() {
  return (
    <div className="flex flex-col gap-4">
      <BreadcrumbWrapper
        crumbArray={[{ path: '/purchases', label: 'Purchases' }]}
      />
      <h1 className="text-2xl font-bold">Purchases</h1>
      <PurchaseList />
    </div>
  );
}
